import './features.scss';
import featuresLogo1 from '../assets/background/features-logo-1.svg';
import featuresLogo2 from '../assets/background/features-logo-2.svg';
import featuresLogo3 from '../assets/background/features-logo-3.svg';

import featuresImage1KOR from '../assets/background/features-image-1.png';
import featuresImage1ENG from '../assets/background/features-image-1-eng.png';
import featuresImage1JPN from '../assets/background/features-image-1-jpn.png';
import featuresImage2KOR from '../assets/background/features-image-2.png';
import featuresImage2ENG from '../assets/background/features-image-2-eng.png';
import featuresImage2JPN from '../assets/background/features-image-2-jpn.png';
import featuresImage3KOR from '../assets/background/features-image-3.png';
import featuresImage3ENG from '../assets/background/features-image-3-eng.png';
import featuresImage3JPN from '../assets/background/features-image-3-jpn.png';
import featuresImage4KOR from '../assets/background/features-image-4.png';
import featuresImage4ENG from '../assets/background/features-image-4-eng.png';
import featuresImage4JPN from '../assets/background/features-image-4-jpn.png';

import bgFeaturesImage1 from '../assets/background/bg-features-1.jpg';
import bgFeaturesImage2 from '../assets/background/bg-features-2.jpg';

import featuresIcon1 from '../assets/icon/features-icon-1.svg';
import featuresIcon2 from '../assets/icon/features-icon-2.svg';
import featuresIcon3 from '../assets/icon/features-icon-3.svg';

import { useTranslation } from 'react-i18next';
import utils from '../core/utils';
import { motionX, motionY, motionScale, motionChildDelayContainer } from 'src/core/animation';
import { motion } from 'framer-motion';
import translateSetting from 'src/core/translate-setting';

const Features = () => {
  return (
    <section id="features" className="Features">
      <FeaturesTitle />
      <FeaturesSection1 />
      <FeaturesSection2 />
      <FeaturesSection3 />
      <FeaturesSection4 />
      <FeaturesSection5 />
      <FeaturesSection6 />
    </section>
  );
};

const FeaturesTitle = () => {
  return (
    <div className="features-title">
      <div className="title-text">FEATURES</div>
      <img className="title-image" src={featuresLogo1} />
    </div>
  );
};

const FeaturesSection1 = () => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();

  let featuresImage1 = featuresImage1KOR;
  if (curLng === 'ENG') {
    featuresImage1 = featuresImage1ENG;
  }
  if (curLng === 'JPN') {
    featuresImage1 = featuresImage1JPN;
  }

  return (
    <motion.div
      className="features-section-text-image"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: false, amount: 0.3 }}
      variants={motionX({ from: 150, to: 0 })}
    >
      <div className="left-section">
        <div className="point-text">FEATURE 1</div>
        <div className="big-text">{t('features.section-1.title-0')}</div>
        <hr />
        <div className="text-box">
          <div className="row">
            <div className="index-text">a</div>
            <div className="small-text">{t('features.section-1.text-0')}</div>
          </div>
          <div className="row">
            <div className="index-text">b</div>
            <div className="small-text">{t('features.section-1.text-1')}</div>
          </div>
          <div className="row">
            <div className="index-text">c</div>
            <div className="small-text">{t('features.section-1.text-2')}</div>
          </div>
        </div>
      </div>
      <div className="right-section">
        <img className="image" src={featuresImage1} />
      </div>
    </motion.div>
  );
};

const FeaturesSection2 = () => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();

  let featuresImage2 = featuresImage2KOR;
  if (curLng === 'ENG') {
    featuresImage2 = featuresImage2ENG;
  }
  if (curLng === 'JPN') {
    featuresImage2 = featuresImage2JPN;
  }

  return (
    <motion.div
      className="features-section-image-text"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: false, amount: 0.3 }}
      variants={motionX({ from: -150, to: 0 })}
    >
      <div className="left-section">
        <img className="image" src={featuresImage2} />
      </div>
      <div className="right-section">
        <div className="point-text">FEATURE 2</div>
        <div className="big-text">{t('features.section-2.title-0')}</div>
        <hr />
        <div className="text-box">
          <div className="row">
            <div className="index-text">a</div>
            <div className="small-text">{t('features.section-2.text-0')}</div>
          </div>
          <div className="row">
            <div className="index-text">b</div>
            <div className="small-text">{t('features.section-2.text-1')}</div>
          </div>
          <div className="row">
            <div className="index-text">c</div>
            <div className="small-text">{t('features.section-2.text-2')}</div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const FeaturesSection3 = () => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();

  let featuresImage3 = featuresImage3KOR;
  if (curLng === 'ENG') {
    featuresImage3 = featuresImage3ENG;
  }
  if (curLng === 'JPN') {
    featuresImage3 = featuresImage3JPN;
  }

  return (
    <motion.div
      className="features-section-text-image"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: false, amount: 0.3 }}
      variants={motionX({ from: 150, to: 0 })}
    >
      <div className="left-section">
        <div className="point-text">FEATURE 3</div>
        <div className="big-text">
          <div className="small-text">{t('features.section-3.title-0')}</div>
        </div>
        <hr />
        <div className="text-box">
          <div className="row">
            <div className="index-text">a</div>
            <div className="small-text">
              <div className="small-text">{t('features.section-3.text-0')}</div>
            </div>
          </div>
          <div className="row">
            <div className="index-text">b</div>
            <div className="small-text">
              <div className="small-text">{t('features.section-3.text-1')}</div>
            </div>
          </div>
          <div className="row">
            <div className="index-text">c</div>
            <div className="small-text">
              <div className="small-text">{t('features.section-3.text-2')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-section">
        <img className="image" src={featuresImage3} />
      </div>
    </motion.div>
  );
};

const FeaturesSection4 = () => {
  const { t } = useTranslation();

  let curLng = translateSetting.getCurrentLanguage();

  let featuresImage4 = featuresImage4KOR;
  if (curLng === 'ENG') {
    featuresImage4 = featuresImage4ENG;
  }
  if (curLng === 'JPN') {
    featuresImage4 = featuresImage4JPN;
  }

  return (
    <motion.div
      className="features-section-image-text"
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: false, amount: 0.3 }}
      variants={motionX({ from: -150, to: 0 })}
    >
      <div className="left-section">
        <img className="image" src={featuresImage4} />
      </div>
      <div className="right-section">
        <div className="point-text">FEATURE 4</div>
        <div className="big-text">{t('features.section-4.title-0')}</div>
        <hr />
        <div className="text-box">
          <div className="row">
            <div className="index-text">a</div>
            <div className="small-text">{t('features.section-4.text-0')}</div>
          </div>
          <div className="row">
            <div className="index-text">b</div>
            <div className="small-text">{t('features.section-4.text-1')}</div>
          </div>
          <div className="row">
            <div className="index-text">c</div>
            <div className="small-text">{t('features.section-4.text-2')}</div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const FeaturesSection5 = () => {
  const { t } = useTranslation();

  return (
    <div className="features-section-why">
      <img className="bg-image" src={bgFeaturesImage1} />
      <motion.div
        className="title-section"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionScale()}
      >
        <div className="point-text">Why?</div>
        <img className="features-logo" src={featuresLogo2} />
        <div className="small-text">{t('features.section-5.title-0')}</div>
        <div className="small-text">{t('features.section-5.title-1')}</div>
      </motion.div>
      <motion.div
        className="left-section"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionY({
          transition: {
            type: 'tween',
            duration: 1.5,
          },
        })}
      >
        <div className="point-text">01</div>
        <img className="icon-image" src={featuresIcon1} />
        <div className="big-text">{t('features.section-5.big-text-0')}</div>
        <div className="small-text">{t('features.section-5.small-text-0-0')}</div>
        <div className="small-text">{t('features.section-5.small-text-0-1')}</div>
      </motion.div>
      <motion.div
        className="middle-section"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionY({
          transition: {
            type: 'tween',
            duration: 1.5,
          },
        })}
      >
        <div className="point-text">02</div>
        <img className="icon-image" src={featuresIcon2} />
        <div className="big-text">{t('features.section-5.big-text-1')}</div>
        <div className="small-text">{t('features.section-5.small-text-1-0')}</div>
        <div className="small-text">{t('features.section-5.small-text-1-1')}</div>
      </motion.div>
      <motion.div
        className="right-section"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionY({
          transition: {
            type: 'tween',
            duration: 1.5,
          },
        })}
      >
        <div className="point-text">03</div>
        <img className="icon-image" src={featuresIcon3} />
        <div className="big-text">{t('features.section-5.big-text-2')}</div>
        <div className="small-text">{t('features.section-5.small-text-2-0')}</div>
        <div className="small-text">{t('features.section-5.small-text-2-1')}</div>
      </motion.div>
    </div>
  );
};

const FeaturesSection6 = () => {
  const { t } = useTranslation();

  return (
    <div className="features-section-statics">
      <img className="bg-image" src={bgFeaturesImage2} />

      <div className="left-section">
        <img className="image" src={featuresLogo3} />
        <div className="small-text">{t('features.section-6.small-title-0')}</div>
      </div>
      <motion.div
        className="right-section"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionChildDelayContainer({ delayChildren: 0, staggerChildren: 0.5 })}
      >
        <motion.div className="card-box" variants={motionY()}>
          <div className="small-text">{t('features.section-6.label-0')}</div>
          <div className="big-text">
            15,642 <b className="unit">{t('features.section-6.unit-0')}</b>
          </div>
          <div className="point-text">{t('features.section-6.point-text-0')}</div>
        </motion.div>
        <motion.div className="card-box" variants={motionY()}>
          <div className="small-text">{t('features.section-6.label-1')}</div>
          <div className="big-text">
            44,808,000 <b className="unit">{t('features.section-6.unit-1')}</b>
          </div>
          <div className="point-text">{t('features.section-6.point-text-1')}</div>
        </motion.div>
        <motion.div className="card-box" variants={motionY()}>
          <div className="small-text">{t('features.section-6.label-2')}</div>
          <div className="big-text">
            191,000 <b className="unit">{t('features.section-6.unit-2')}</b>
          </div>
          <div className="point-text">{t('features.section-6.point-text-2')}</div>
        </motion.div>
        <motion.div className="card-box" variants={motionY()}>
          <div className="small-text">{t('features.section-6.label-3')}</div>
          <div className="big-text">
            84,600 <b className="unit">{t('features.section-6.unit-3')}</b>
          </div>
          <div className="point-text">{t('features.section-6.point-text-3')}</div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Features;
